import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Tooltip ,
  IconButton ,
  CircularProgress,
  Modal,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle, 
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEmailDL, getSalesOffices } from "../../utils/GetAdmin";
import { saveEmailDL } from "../../utils/PostAdmin";
import requestMissingContexts, { determineConfig, determineConfigLong, displayConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
interface rowData {
  salesOffice: string;
  deliveringPlant: string;
  dlName: string;
  email: string;
}
export default function AdminEmailDL() {
  const classes = useStyles();
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [emailDL, SetEmailDL] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_admin');
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);

  
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});

  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [editedRow, setEditedRow] = React.useState<rowData|undefined>(undefined);

  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowDlName, setEditedRowDlName] = React.useState<string>("");
  const [editedRowEmail, setEditedRowEmail] = React.useState<string>("");

  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRow(undefined);
    setEditedRowDeliveringPlant("");
    setEditedRowDlName("");
    setEditedRowEmail("");
  }

  
  const handleModalSave = () => {
    let oldEmail = (editedRow) ? {deliveringPlant: editedRow.deliveringPlant, salesOffice: editedRow.deliveringPlant, dlName:editedRow.dlName, email:editedRow.email} : undefined;
    let newEmail = {deliveringPlant: editedRowDeliveringPlant, salesOffice: editedRowDeliveringPlant, dlName:editedRowDlName, email:editedRowEmail};
    saveEmailDL(salesOrg,oldEmail,newEmail).then(ret => {
      if(ret && ret.data){
        SetEmailDL(ret.data.mdEmailDl)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setOpenEditWindow(false);
    setEditedRow(undefined);
  } 
  const handleDelete = () => {
    let oldEmail = {deliveringPlant: editedRowDeliveringPlant, salesOffice: editedRowDeliveringPlant, dlName:editedRowDlName, email:editedRowEmail};
    saveEmailDL(salesOrg,oldEmail,undefined).then(ret => {
      if(ret && ret.data){
        SetEmailDL(ret.data.mdEmailDl)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setEditedRow(undefined);
  }
  const handleEdit = (tableMeta:any) => {
   if(tableMeta) setCurrent(tableMeta);
    setOpenEditWindow(true);
  }
  const setCurrent = (tableMeta:any) => {
    // let cur:any = tableMeta.currentTableData[tableMeta.rowIndex];
    setEditedRow(tableMeta);
    setEditedRowDeliveringPlant(tableMeta.deliveringPlant);
    setEditedRowDlName(tableMeta.dlName);
    setEditedRowEmail(tableMeta.email);
  }

const modalBody = (
  <div style={modalStyle} className={classes.paper} >
  <Typography variant="h4" className={classes.modalTitle} paragraph>Email Subscription</Typography>
  <Grid container spacing={2}  className={classes.modalGrid}>
    <Grid item xs={14} md={14} xl={12}>
      <Typography variant="subtitle1" className={classes.modalText} paragraph>
        {editedRowDlName === "*" ? "Recieve all email notifications sent to the specified sales org." : determineConfigLong(codes, "vp_email_dl", editedRowDlName)}
      </Typography>
      <Card className={classes.modalCard}>
        <CardContent>
        <Grid container rowSpacing={3} className={classes.modalGrid}>
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Delivery Plant</InputLabel>
            <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                inputProps={{name: 'Delivery Plant',}}
                className={classes.modalInput}
                onChange={(e) => { 
                    setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                <MenuItem key='*' value='*'>{salesOrg + " - All"}</MenuItem>
                {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<div></div>)}
            </Select>
          </Grid>
          <Grid item xs={3} md={6} xl={6}>
            <InputLabel >Subscription</InputLabel>
            <Select label="Subscription"  value={editedRowDlName}
                className={classes.modalInput}
                onChange={(e) => { 
                    setEditedRowDlName((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                  }}>
                  <MenuItem key='*' value='*'>{"All"}</MenuItem>
                {displayConfig(codes, "vp_email_dl")?.map((dl: any, i: number) => (
                    <MenuItem key={dl.code} value={dl.code}>
                      {dl.text}
                    </MenuItem>
                  ))} 
            </Select>
          </Grid>
          <Grid item xs={2} md={2} xl={4}>
            <InputLabel >Email</InputLabel>
            <TextField placeholder='Email' type='text'
                className={classes.modalInput}
                value={editedRowEmail}
                onChange={(e) => { 
                  setEditedRowEmail((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                }}></TextField>
            </Grid>
          </Grid>
          </CardContent>
        </Card>
        <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Save"}>
                      <IconButton onClick={handleModalSave}>
                          <SaveIcon />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
            </div>
      </Grid>
    </Grid>
  </div>
);

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["vp_email_dl", "SALESOFFICES", "PLANTS"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        GetEmailDL(salesOrg).then((v) => {
          if(v && v.mdEmailDl) SetEmailDL(v.mdEmailDl);
        }).then((_) => {
          getSalesOffices(salesOrg)
            .then((v) => {
              setDeliveringPlants(v);
              setDoneLoading(true);
            });
          });
      });
  }, [emailDL,doneLoading,salesOrg,muiTable,confirmDelete]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <TableAbstraction
        settingsKey="ADM_EDL"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Email`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setEditedRowDeliveringPlant("*");
                    setEditedRowDlName("*");
                    setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Email Subscriptions"
          columns={[
            {
              label: "Sales Office",
              name: "salesOffice",
              options: {
                filter: true,
                customBodyRender: (value: any) =>
                value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "SALESOFFICES", value)}` ,
              },
            },
            {
              label: "Delivery Plant",
              name: "deliveringPlant",
              options: {
                filter: true,
                customBodyRender: (value: any) =>
                value === '*' ? salesOrg :`${value} - ${determineConfig(codes, "PLANTS", value)}` ,
              },
            },
            {
              label: "Subscription",
              name: "dlName",
              options: {
                filter: true,
                customBodyRender: (value: any) => {
                  return (
                    <Tooltip title={`${value === "*" ? "Recieve all email notifications sent to the specified sales org." : determineConfigLong(codes, "vp_email_dl", value)}`}>
                      <div>
                      {`${value === "*" ? "All" : determineConfig(codes, "vp_email_dl", value)}` || value}
                      </div>
                    </Tooltip>
                  );
                },
              },
            },
            {
              label: "Email Address",
              name: "email",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: " ",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (props) => {
                  const tableMeta = props.row;
                    if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <EditIcon 
                              fontSize="small"  
                              onClick={() => {handleEdit(tableMeta)}}/>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <DeleteIcon
                              fontSize="small" 
                              onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}} 
                            />
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <IconButton onClick={() => {handleEdit(tableMeta)}}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                }
                // customBodyRender: (value: any, tableMeta: any) => {
                //   if(rowData) tableMeta = rowData;
                //   console.log('tableMeta', tableMeta, value);
                //   if(!!useCompact)
                //     return (
                //         <React.Fragment>
                //           <Tooltip title={"Edit"}>
                //             <EditIcon 
                //               fontSize="small"  
                //               onClick={() => {handleEdit(tableMeta)}}/>
                //           </Tooltip>
                //           <Tooltip title={"Delete"}>
                //             <DeleteIcon
                //               fontSize="small" 
                //               onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}} 
                //             />
                //           </Tooltip>
                //         </React.Fragment>
                //       );
                //     else
                //       return (
                //           <React.Fragment>
                //             <Tooltip title={"Edit"}>
                //               <IconButton onClick={() => {handleEdit(tableMeta)}}>
                //                 <EditIcon />
                //               </IconButton>
                //             </Tooltip>
                //             <Tooltip title={"Delete"}>
                //               <IconButton onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}}>
                //                 <DeleteIcon />
                //               </IconButton>
                //             </Tooltip>
                //           </React.Fragment>
                //         );
                // },
              },
            },
          ]}
          data={emailDL}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      
      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>

        <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete the email {editedRowEmail}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}